import ProjectBreadcrumb from '../project-tables/ProjectBreadcrumb'
import ApprovalPolicyList from './ApprovalPolicyList'

export default function ApprovalPoliciesPage() {
  return (
    <>
      <ProjectBreadcrumb label="Approvals" url="../approvals" />

      {/* The list renders the settings page, so its "New policy" action can
          sit in the page heading next to the editing state it opens. */}
      <ApprovalPolicyList />
    </>
  )
}
